module.exports = __webpack_public_path__ + "media/phase-2-complete.4bf3b8fe.mp4";